import React, { useState } from 'react'
import styled from 'styled-components'
import useScreenSize from 'hooks/use-screen-size'
import Slider from './Slider'
import Carousel from './Carousel'
import SliderInModal from './SliderInModal'

const Wrapper = styled.div`
  .slider-content {
    overflow: 'hidden';
    transition: 0.2s ease;
  }
`

interface Props {
  images: string[]
}

const Gallery = ({ images }: Props) => {
  const [activeSlide, setActiveSlide] = useState(0)
  const [modalIsOpen, setModal] = useState(false)

  const { isSmallScreen, isLargeScreen } = useScreenSize()

  const openModal = () => setModal(true)

  const closeModal = () => setModal(false)

  const commonProps = {
    images,
    activeSlide,
    setActiveSlide,
    isSmallScreen,
    isLargeScreen,
  }

  return (
    <Wrapper>
      <div className="slider-content" style={{ opacity: +!modalIsOpen }}>
        <Slider openModal={openModal} {...commonProps} />
        {isLargeScreen && <Carousel {...commonProps} />}
      </div>
      <SliderInModal
        {...commonProps}
        isOpen={modalIsOpen}
        closeModal={closeModal}
      />
    </Wrapper>
  )
}

export default Gallery
